import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { X, UserPlus } from 'lucide-react';
import api from '../utils/api';
import { toast } from 'sonner';

export default function ClientModal({ onClose, onSuccess }) {
  const [form, setForm] = useState({ name: '', email: '', phone: '' });
  const [loading, setLoading] = useState(false);

  const set = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return;
    setLoading(true);
    try {
      const { data } = await api.post('/clients', form);
      toast.success('Cliente cadastrado!');
      onSuccess(data);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro ao cadastrar cliente');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-stone-400 hover:text-stone-600 transition-colors"
        >
          <X size={20} />
        </button>

        <div className="flex items-center gap-3 mb-5">
          <div className="w-9 h-9 rounded-lg bg-[#064E3B]/10 flex items-center justify-center">
            <UserPlus size={18} className="text-[#064E3B]" />
          </div>
          <h2 className="text-lg font-bold text-stone-900" style={{ fontFamily: 'Playfair Display, serif' }}>
            Novo Cliente
          </h2>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-1.5">
            <Label className="text-sm font-semibold text-stone-700">Nome *</Label>
            <Input
              data-testid="client-name-input"
              placeholder="Nome do cliente"
              value={form.name}
              onChange={set('name')}
              required
              className="border-stone-200"
            />
          </div>
          <div className="space-y-1.5">
            <Label className="text-sm font-semibold text-stone-700">E-mail</Label>
            <Input
              data-testid="client-email-input"
              type="email"
              placeholder="email@exemplo.com"
              value={form.email}
              onChange={set('email')}
              className="border-stone-200"
            />
          </div>
          <div className="space-y-1.5">
            <Label className="text-sm font-semibold text-stone-700">Telefone</Label>
            <Input
              data-testid="client-phone-input"
              placeholder="+55 48 99999-0000"
              value={form.phone}
              onChange={set('phone')}
              className="border-stone-200"
            />
          </div>
          <div className="flex gap-3 pt-1">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              className="flex-1 border-stone-200"
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              data-testid="client-submit-btn"
              disabled={loading}
              className="flex-1 bg-[#064E3B] hover:bg-[#022C22] text-white"
            >
              {loading ? (
                <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
              ) : (
                'Cadastrar'
              )}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
